import React, { useEffect, useRef, useState } from "react";
import { DateRangePicker } from "react-date-range";
import { addDays } from "date-fns";
import { TextField, IconButton, Box, InputAdornment, FormHelperText } from "@mui/material";
import { CalendarOutlined, CloseOutlined } from "@ant-design/icons";
import moment from "moment/moment";
import { isEmpty } from "lodash";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import "./CustomDatePicker.css";

const CustomDateRangePicker = ({
  selectedDate,
  handleDateChange,
  minDate,
  maxDate,
  months = null,
  resetTrigger,
  hidePresets = false,
  centeredPicker = false,
  touched,
  error,
  InputId,
  helperText,
}) => {
  const [filterBy, setFilterBy] = useState({});
  const [date, setDate] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);
  const wrapperRef = useRef(null);
  const [showDatePicker, setShowDatePicker] = useState(false);

  const handleClickOutside = (event) => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      setShowDatePicker(false);
    }
  };


  const handleDatePicker = (date) => {
    handleDateChange(date)
  }

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  useEffect(() => {
    if (resetTrigger) {
      setDate([{
        startDate: new Date(),
        endDate: new Date(),
        key: "selection",
      }]);
      setFilterBy({});
    }
  }, [resetTrigger]);
  useEffect(() => {
    if (selectedDate && selectedDate.from && selectedDate.to) {
      setDate([{
        startDate: moment(selectedDate.from, months ? "DD/MM/YYYY" : "DD/MM/YYYY").toDate(),
        endDate: moment(selectedDate.to, months ? "DD/MM/YYYY" : "DD/MM/YYYY").toDate(),
        key: "selection",
      }]);
    }
  }, [selectedDate, months]);

  const formatDisplayValue = () => {
    if (!selectedDate || !selectedDate.from || !selectedDate.to) return "";
    return `${selectedDate.from} - ${selectedDate.to}`;
  };

  return (
    <Box position="relative" display="inline-block" ref={wrapperRef} className="w-100 pending_task_bg" >
      <TextField
        placeholder="Select Date Range"
        // value={filterBy?.from ? filterBy?.from + " - " + filterBy?.to : ""}
        value={formatDisplayValue()}
        InputProps={{
          readOnly: true,
          endAdornment: (
            <InputAdornment position="end" className="innerInput">
              {selectedDate && selectedDate?.from && selectedDate?.to &&
                <IconButton
                  sx={{
                    borderRadius: '50%',
                  }}
                  onClick={() => {
                    handleDateChange({});
                    setFilterBy({});
                    setDate([{
                      startDate: new Date(),
                      endDate: new Date(),
                      key: "selection",
                    }]);
                  }}
                >
                  <CloseOutlined style={{ color: "red" }} />
                </IconButton>

              }
              <IconButton onClick={() => setShowDatePicker(!showDatePicker)} >
                <CalendarOutlined />
              </IconButton>
            </InputAdornment>
          ),
        }}
        sx={{ backgroundColor: "white", borderColor: "#ccc" }}
        className="hide-legend date-input w-100"
      />
      {showDatePicker && (
        <Box position={centeredPicker ? "fixed" : "absolute"}
          top={centeredPicker ? "50%" : undefined}
          left={centeredPicker ? "50%" : undefined}
          sx={{
            zIndex: 1,
            transform: centeredPicker ? "translate(-50%, -50%)" : undefined,
            backgroundColor: "white",
            boxShadow: 3,
            borderRadius: 2,
          }}>
          <>
            <DateRangePicker
              onChange={(item) => {
                setDate([item.selection]);
              }}
              format="DD/MM/YYYY"
              showSelectionPreview={true}
              moveRangeOnFirstSelection={false}
              months={months ? months : 2}
              ranges={date}
              direction="horizontal"
              className={`custom-range-picker${hidePresets ? " no-presets" : ""}`}
              inputRanges={hidePresets ? [] : undefined}
              staticRanges={hidePresets ? [] : undefined}
              {...(minDate && { minDate })}
              {...(maxDate && { maxDate })}
            />
            <div className="d-flex justify-content-end calenderBtn">
              <button
                className="bg-transparent hover:!bg-[#007bff] text-[#007bff] font-semibold hover:text-white py-2 px-4 border border-[#007bff] hover:border-transparent rounded"
                onClick={() => {
                  setDate([
                    {
                      startDate: new Date(),
                      endDate: addDays(new Date(), 0),
                      key: "selection",
                    },
                  ]);
                  setShowDatePicker(true);

                  setFilterBy({
                    ...filterBy,
                    from: "",
                    to: "",
                  });
                  handleDatePicker({
                    ...filterBy,
                    from: "",
                    to: "",
                  });
                }}

              >
                Reset
              </button>
              <button
                className="bg-[#007bff] hover:bg-[#007bff] text-white font-bold py-2 px-4 rounded ml-3"
                onClick={() => {
                  setFilterBy({
                    ...filterBy,
                    from: moment(!isEmpty(date) && date[0]?.startDate).format(
                      months ? "DD/MM/YYYY" : "DD/MM/YYYY" //@info updating the format for pending task 
                    ),
                    to: moment(!isEmpty(date) && date[0]?.endDate).format(
                      months ? "DD/MM/YYYY" : "DD/MM/YYYY"
                    ),
                  });
                  setShowDatePicker(false);
                  handleDatePicker({
                    ...filterBy,
                    from: moment(!isEmpty(date) && date[0]?.startDate).format(
                      months ? "DD/MM/YYYY" : "DD/MM/YYYY"
                    ),
                    to: moment(!isEmpty(date) && date[0]?.endDate).format(
                      months ? "DD/MM/YYYY" : "DD/MM/YYYY"
                    ),
                  })
                }}
              >
                Apply
              </button>
            </div>
          </>
        </Box>
      )}
      {touched && error && (
        <FormHelperText
          className="absolute left-0 -bottom-6 ml-0 "
          error
          id={`standard-weight-helper-text-${InputId}`}
        >
          {helperText}
        </FormHelperText>
      )}
    </Box>
  );
};

export default CustomDateRangePicker;
